import React from "react";

const Confidentiality = () => {
  return (
    <React.Fragment>
      <h1>Confidentiality</h1>
      <p>
        CJBE keeps all details about a submitted manuscript confidential and does not comment to any
        outside organization about manuscripts that are either under consideration or that have been
        rejected.
      </p>
      <p>
        After a manuscript is submitted, correspondence with CJBE, referee reports, and other
        confidential material, regardless of whether the submission is eventually published, must
        not be posted on any website or otherwise publicized without prior permission. The Editorial
        Board Members themselves are not allowed to discuss manuscripts with third parties or reveal
        information about correspondence and other interactions with authors and referees.
      </p>
      <p>
        Referees of manuscripts submitted to CJBE undertake in advance to maintain the
        confidentiality of manuscripts and any associated supplementary data.
      </p>
    </React.Fragment>
  );
};

export default Confidentiality;
